import React from "react";
import Email from "../../../sections/CustomerDashboard/Settings/Email";
import { AdminPageTitle } from "../../../sections/AdminDashboard/shared/adminUx";
import DashboardMainContainer from "../../../components/common/Containers/DashboardMainContainer";
import { CUSTOMER_CENTERED_PAGE_TITLE_CLASS } from "../../../sections/CustomerDashboard/shared/customerLayoutSpec";

const CustomerEmail = () => {
  return (
    <DashboardMainContainer className="lg:px-5 lg:pb-10">
      <AdminPageTitle className={`text-offblack ${CUSTOMER_CENTERED_PAGE_TITLE_CLASS}`}>
        Update email address
      </AdminPageTitle>
      <div className="flex justify-center min-h-screen">
        <Email />
      </div>
    </DashboardMainContainer>
  );
};

export default CustomerEmail;
